import React from "react";
import { __ } from "@wordpress/i18n";

const AddonForm = ({ addon, onChange, onDelete, onAddChild }) => {
    const handleFieldChange = (field, value) => {
        console.log("Field:", field);
        console.log("Value:", value);
        onChange({ ...addon, [field]: value });
    };

    const handleAddChildAddon = () => {
        const newChild = {
            id: Date.now(),
            name: "",
            type: "text",
            price: 0,
            parentId: addon.id,
            children: [],
        };
        const updatedChildren = [...(addon.children || []), newChild];
        handleFieldChange("children", updatedChildren);
    };

    const handleChildChange = (childId, updatedChild) => {
        const updatedChildren = addon.children.map((child) =>
            child.id === childId ? updatedChild : child
        );
        handleFieldChange("children", updatedChildren);
    };

    const handleDeleteChild = (childId) => {
        const updatedChildren = addon.children.filter((child) => child.id !== childId);
        handleFieldChange("children", updatedChildren);
    };

    const openMediaUploader = (addon, index) => {
        const mediaUploader = wp.media({
            title: __("Select Image", "woocommerce-addon-plugin"),
            button: { text: __("Use this image", "woocommerce-addon-plugin") },
            multiple: false,
        });

        mediaUploader.on("select", () => {
            const attachment = mediaUploader.state().get("selection").first().toJSON();
            if (attachment && attachment.id) {
                handleFieldChange('subItems', addon.subItems.map((item, i) => {
                    if (i === index) {
                        let image = {
                            'id': attachment.id,
                            'url': attachment.url,
                        };
                        return { ...item, value: image };
                    }
                    return item;
                }));
            } else {
                console.error("No attachment ID found.");
            }
        });

        mediaUploader.open();
    };

    return (
        <div className={`addon-form ${addon.type === "parent" ? "parent-addon" : ""}`}>
            <label>
                {__("Addon Name:", "woocommerce-addon-plugin")}
                <input
                    type="text"
                    value={addon.name || ""}
                    onChange={(e) => handleFieldChange("name", e.target.value)}
                />
            </label>
            <label>
                {__("Addon Type:", "woocommerce-addon-plugin")}
                <select
                    value={addon.type || ""}
                    onChange={(e) => handleFieldChange("type", e.target.value)}
                >
                    <option value="text">{__("Text", "woocommerce-addon-plugin")}</option>
                    <option value="image">{__("Image", "woocommerce-addon-plugin")}</option>
                    <option value="color">{__("Color", "woocommerce-addon-plugin")}</option>
                    <option value="radio">{__("Radio Button", "woocommerce-addon-plugin")}</option>
                </select>
            </label>
            <label>
                {__("Price:", "woocommerce-addon-plugin")}
                <input
                    type="number"
                    step="0.01"
                    value={addon.price || 0}
                    onChange={(e) => handleFieldChange("price", parseFloat(e.target.value))}
                />
            </label>

            {addon.type === "parent" && (
                <>
                    <label>
                        {__("Parent Image:", "woocommerce-addon-plugin")}
                        {addon.parentImage?.url && <img src={addon.parentImage.url} alt={__("Parent Image", "woocommerce-addon-plugin")} className="parent-image" />}
                        <button
                            type="button"
                            className="button button-secondary"
                            onClick={() => openMediaUploader("parentImage")}
                        >
                            {__("Select Image", "woocommerce-addon-plugin")}
                        </button>
                    </label>

                    <div className="child-addons">
                        <h4 className="child-addon-title">{__("Child Addons:", "woocommerce-addon-plugin")}</h4>
                        {addon.children?.map((child) => (
                            <AddonForm
                                key={child.id}
                                addon={child}
                                onChange={(updatedChild) => handleChildChange(child.id, updatedChild)}
                                onDelete={handleDeleteChild}
                            />
                        ))}
                        <button type="button" className="button button-primary add-child-addon" onClick={handleAddChildAddon}>
                            {__("Add Child Addon", "woocommerce-addon-plugin")}
                        </button>
                    </div>
                </>
            )}

            {addon.type !== "parent" && (
                <div className="sub-items">
                    <h4 className="sub-item-title">{__("Options:", "woocommerce-addon-plugin")}</h4>
                    {addon.subItems?.map((subItem, index) => (
                        <div key={subItem.id} className="sub-item">
                            {addon.type === "text" && (
                                <label>
                                    {__("Text:", "woocommerce-addon-plugin")}
                                    <input
                                        type="text"
                                        value={subItem.value || ""}
                                        placeholder={__("Enter text", "woocommerce-addon-plugin")}
                                        onChange={(e) =>
                                            handleFieldChange("subItems", addon.subItems.map((item, i) =>
                                                i === index ? { ...item, value: e.target.value } : item
                                            ))
                                        }
                                    />
                                </label>
                            )}
                            {addon.type === "image" && (
                                <label>
                                    {__("Image:", "woocommerce-addon-plugin")}
                                    {subItem.value?.url && (
                                        <img src={subItem.value.url} alt={__("Sub-Item Image", "woocommerce-addon-plugin")} className="sub-item-image" />
                                    )}
                                    <button
                                        type="button"
                                        className="button button-secondary"
                                        onClick={() => openMediaUploader(addon, index)}
                                    >
                                        {__("Select Image", "woocommerce-addon-plugin")}
                                    </button>
                                </label>
                            )}
                            {addon.type === "color" && (
                                <label>
                                    {__("Color:", "woocommerce-addon-plugin")}
                                    <input
                                        type="color"
                                        value={subItem.value || "#000000"}
                                        onChange={(e) =>
                                            handleFieldChange("subItems", addon.subItems.map((item, i) =>
                                                i === index ? { ...item, value: e.target.value } : item
                                            ))
                                        }
                                    />
                                </label>
                            )}
                            {addon.type === "radio" && (
                                <label>
                                    {__("Radio Option:", "woocommerce-addon-plugin")}
                                    <input
                                        type="text"
                                        value={subItem.value || ""}
                                        placeholder={__("Enter radio option", "woocommerce-addon-plugin")}
                                        onChange={(e) =>
                                            handleFieldChange("subItems", addon.subItems.map((item, i) =>
                                                i === index ? { ...item, value: e.target.value } : item
                                            ))
                                        }
                                    />
                                </label>
                            )}
                            <label>
                                {__("Price:", "woocommerce-addon-plugin")}
                                <input
                                    type="number"
                                    step="0.01"
                                    value={subItem.price || 0}
                                    onChange={(e) =>
                                        handleFieldChange("subItems", addon.subItems.map((item, i) =>
                                            i === index ? { ...item, price: parseFloat(e.target.value) } : item
                                        ))
                                    }
                                />
                            </label>
                            <button
                                type="button"
                                className="button button-secondary remove-sub-item"
                                onClick={() =>
                                    handleFieldChange("subItems", addon.subItems.filter((_, i) => i !== index))
                                }
                            >
                                {__("Remove", "woocommerce-addon-plugin")}
                            </button>
                        </div>
                    ))}
                    <button
                        type="button"
                        className="button button-primary"
                        onClick={() =>
                            handleFieldChange("subItems", [
                                ...(addon.subItems || []),
                                { value: "", price: 0, id: Date.now() },
                            ])
                        }
                    >
                        {__("Add Sub-Item", "woocommerce-addon-plugin")}
                    </button>
                </div>
            )}

            <button type="button" className="button button-secondary" onClick={() => onDelete(addon.id)}>
                {__("Delete Addon", "woocommerce-addon-plugin")}
            </button>
        </div>
    );
};

export default AddonForm;
